// extracted by mini-css-extract-plugin
export default {"topnav":"topnav_topnav__CwWaS","section":"topnav_section__5upGJ","spacer":"topnav_spacer__Fe6fi","title":"topnav_title__VdI0V","action":"topnav_action__8Rdc2"};